var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"glow-container d-none d-sm-none d-md-none d-lg-block",style:({'height': (_vm.windowHeight + "px")})},_vm._l((_vm.glowsArray),function(val,i){return _c('div',{key:("glow" + i),staticClass:"glowworm",style:({
      'left': ((10+(i % 3 * 40)) + "%"),
      'top': ((i*500) + "px"),
    })},[_c('div',{staticClass:"glow"})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }